import { render, staticRenderFns } from "./wlnwarehouse.vue?vue&type=template&id=e06a5e5c&scoped=true&"
import script from "./wlnwarehouse.vue?vue&type=script&lang=js&"
export * from "./wlnwarehouse.vue?vue&type=script&lang=js&"
import style0 from "./wlnwarehouse.vue?vue&type=style&index=0&id=e06a5e5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06a5e5c",
  null
  
)

export default component.exports